import ShopifyCartModule from '../class/ShopifyCartModule';
import cartMixin from '../vue-mixins/cart-mixin';
import cartModalSwipeMixin from '../vue-mixins/cart-modal-swipe-mixin';
import { html } from '../utils/environment';
import { FocusTrap } from 'focus-trap-vue'
import { getFirstFocusableElement } from '../utils/getFirstFocusableElement';
import cartCheckoutMixin from '../vue-mixins/cart-checkout-mixin';

Vue.component('FocusTrap', FocusTrap)

export default class extends ShopifyCartModule {
    constructor(m) {
        super(m);
    }

    async init() {
        // Await cart state
        await super.init()

        // Events
        this.closeBind = (e) => {
            if (e.key === "Escape") {
                this.onCloseModal();
            }
        }
        this.bindEvents()

        // Init vue
        this.initVue()
    }

    initVue() {
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this;

        /////////////////////////
        // Settings
        Vue.config.devtools = true;

        /////////////////////////
        // Vue Instance
        this.app = new Vue({
            el: this.el,

            delimiters: ["${", "}"],

            data: {
                isActive: false
            },

            mixins: [cartMixin, cartModalSwipeMixin, cartCheckoutMixin],

            beforeCreate() {
                this.moduleInstance = moduleInstance
            },

            methods: {
                onActiveTrap() {
                    this.isActive = true
                    getFirstFocusableElement(this.$el)
                },

                onUnactiveTrap() {
                    this.isActive = false
                }
            }
        });
    }

    bindEvents() {
        document.addEventListener('keyup', this.closeBind)
    }

    unbindEvents() {
        document.removeEventListener('keyup', this.closeBind)
    }

    onOpenModal() {
        html.classList.add('has-cart-open')

        // Open Swipe Cart Vue
        this.app?.openSwipeCart?.()

        // Close search bar
        this.call('close', null, 'Search')
        // Close menu
        this.call('close', null, 'Menu')

        // Active trap
        setTimeout(() => {
            this.app?.onActiveTrap?.()
        }, 600)
    }

    onCloseModal() {
        html.classList.remove('has-cart-open')

        // Close Swipe Cart Vue
        this.app?.closeSwipeCart?.()

        // Unactive trap
        this.app?.onUnactiveTrap?.()
    }

    onOpenSwipeModal() { }

    onCloseSwipeModal() { }

    // Hooks
    onAddItem(cart) {
        //console.log('[add] - addedItem from product form', cart)

        // Open Modal
        this.onOpenModal()

        /* /!\ Refresh Cart Vue.js */
        this.app?.onAddNewItem?.(cart)

        // Set Cart counter
        this.setCartCounter(cart)
    }

    onRemoveItem(cart) {
        //console.log('[remove] - lastCart', cart)
        this.setCartCounter(cart)
    }

    onUpdateItem(cart) {
        //console.log('[update] - lastCart', cart)
        this.setCartCounter(cart)
    }

    onRefreshCart(cart) {
        //console.log('[refresh] - lastCart', cart)
        this.setCartCounter(cart)
    }

    onCannotAddMoreItem(itemId) {
        this.call('cannotAddMoreItem', itemId, 'ProductForm')
    }

    setCartCounter(cart) {
        const cartLength = cart.item_count
        this.call('setCartCounter', cartLength, 'CartCounter')
    }

    setCartData(cartState) {
        this.call('setVueCartData', cartState, 'Cart')
    }

    setVueCartData(cartState) {
        this.app?.setCartData?.(cartState, true)
    }

    destroy() {
        super.destroy();

        this.unbindEvents();

        if (this.app) {
            this.app.$destroy();
        }
    }
}
